import Checkbox from '@mui/material/Checkbox';
import {styled} from '@mui/material/styles';

const TwoToneCheckbox = styled(Checkbox)(() => ({
    'color': '#989390 !important',

    '&:hover': {
        color: '#454545 !important',
        backgroundColor: 'transparent !important',
    },

    '&.Mui-checked': {
        'color': '#989390 !important',
        '&:hover': {
            color: '#454545 !important',
            backgroundColor: 'transparent !important',
        },
    },

    '&.MuiCheckbox-indeterminate': {
        'color': '#989390 !important',
        '&:hover': {
            color: '#454545 !important',
            backgroundColor: 'transparent !important',
        },
    },
}));

export default TwoToneCheckbox;
